module.exports = {"610422001":"城关街道","610422102":"陂西镇","610422103":"独李镇","610422104":"大程镇","610422105":"西阳镇","610422106":"鲁桥镇","610422107":"陵前镇","610422109":"新兴镇","610422110":"嵯峨镇","610422111":"渠岸镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/610422.json
// module id = 2946
// module chunks = 0